var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackWarningIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.863636 13.6299L8.56818 0.538973L16.2727 13.6299H0.863636ZM8.56818 12.164C8.85985 12.164 9.10795 12.0617 9.3125 11.8572C9.52083 11.6488 9.625 11.3988 9.625 11.1072C9.625 10.8155 9.52083 10.5674 9.3125 10.3628C9.10795 10.1545 8.85985 10.0503 8.56818 10.0503C8.27652 10.0503 8.02652 10.1545 7.81818 10.3628C7.61364 10.5674 7.51136 10.8155 7.51136 11.1072C7.51136 11.3988 7.61364 11.6488 7.81818 11.8572C8.02652 12.0617 8.27652 12.164 8.56818 12.164ZM7.875 8.76625H9.26136L9.36364 4.90261H7.77273L7.875 8.76625Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackWarningIcon);
export default __webpack_public_path__ + "static/media/BlackWarningIcon.5a819ecd78e5477a30ff0c08b41c00b3.svg";
export { ForwardRef as ReactComponent };